import { v4 as uuidv4 } from 'uuid';

import { NOTIFY_API_ERROR, CLEAR_API_ERRORS, DISMISS_API_ERROR } from '../constants/actionTypes';

const dismiss = (array, id) => {
  const clonedArray = array.slice(0);

  const index = clonedArray.map(error => error.id).indexOf(id);
  clonedArray.splice(index, 1);

  return clonedArray;
};

export const initialState = [];

const apiErrors = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case NOTIFY_API_ERROR: {
      const { error } = action;
      const newState = state.slice(0);

      newState.push({
        id: uuidv4(),
        error,
      });

      return newState;
    }

    case DISMISS_API_ERROR: {
      const { errorId } = action;

      return dismiss(state, errorId);
    }

    case CLEAR_API_ERRORS:
      return initialState;

    default:
      return state;
  }
};

export default apiErrors;
